import React from 'react';
import { Event } from '../../types/events.types';
import { format } from 'date-fns';
import { EVENTS_PATH } from '../../../utilities/devex_paths';
const CLOUDINARY_BASE_PATH = 'https://res.cloudinary.com/devex/image';
const FALLBACK_IMAGE = 'devex-generic-cccdb08fd0bb6bcf8a8a2d3b6c21a76b.png';
const rowMaxHeight = 184;

const EVENT_PREVIEW_IMAGE_PATH_FOR_DESKTOP = `
  ${CLOUDINARY_BASE_PATH}/fetch/c_fill,q_auto,f_auto,h_${rowMaxHeight},w_264/
`;

const FALLBACK_EVENT_IMAGE_URL_FOR_DESKTOP = `
  ${CLOUDINARY_BASE_PATH}/asset/c_fill,q_auto,f_auto,h_${rowMaxHeight},w_264/${FALLBACK_IMAGE}
`;

const EVENT_PREVIEW_IMAGE_PATH_FOR_MOBILE = `
  ${CLOUDINARY_BASE_PATH}/fetch/c_fill,q_auto,f_auto,h_${rowMaxHeight},w_520/
`;

const FALLBACK_EVENT_SRC_URL_FOR_MOBILE = `
  ${CLOUDINARY_BASE_PATH}/asset/c_fill,q_auto,f_auto,h_${rowMaxHeight},w_520/${FALLBACK_IMAGE}
`;

interface Props {
  event: Event;
  plausibleSection: string;
}

const PastEvent: React.FC<Props> = ({ event, plausibleSection }) => {
  const EVENT_PATH = `${EVENTS_PATH}/${event.slug_and_id}`;

  const isRedirect = event.external_registration_url && !event.recording_article;
  const eventPath = isRedirect ? event.external_registration_url : EVENT_PATH;

  const externalLinkProps = isRedirect
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};

  // Decide which image to use for the event thumbnail.
  // Use thumbnail file if available; otherwise, use preview_image.
  const thumbnailUrl = event?.thumbnail && event.thumbnail?.public_url || event?.preview_image;
  // If neither is available, use the fallback image URL.
  const eventImageUrlForMobile = thumbnailUrl
    ? EVENT_PREVIEW_IMAGE_PATH_FOR_MOBILE + thumbnailUrl
    : FALLBACK_EVENT_SRC_URL_FOR_MOBILE;

  const renderImageForMobile = (
    <div className='d-block d-md-none'>
      <img src={eventImageUrlForMobile} alt={event.title} className='card-img-top' loading='lazy'/>
    </div>
  );

  const eventImageUrlForDesktop = thumbnailUrl
    ? EVENT_PREVIEW_IMAGE_PATH_FOR_DESKTOP + thumbnailUrl
    : FALLBACK_EVENT_IMAGE_URL_FOR_DESKTOP;
  const renderImageForDesktop = (
    <div className='d-none d-md-block'>
      <img src={eventImageUrlForDesktop} alt={event.title} className='img-fluid' loading='lazy'/>
    </div>
  );

  const plausibleEventClass = `
    plausible-event-name=click
    plausible-event-intention=view-event-details
    plausible-event-section=${plausibleSection}-past-events`;

  return (
    <div className='col'>
      <div className='card border-0 h-100'>
        <a
          href={eventPath}
          className={`stretched-link ${plausibleEventClass}`}
          {...externalLinkProps}
        >
          {renderImageForMobile}
          {renderImageForDesktop}
          <div className='card-body ps-1'>
            <h3 className='fs-5 card-title text-gray-dark'>
              {event.title}
            </h3>
            <p className='card-text'>
              <i className='fal icon-calendar-alt pe-15' />
              {format(new Date(event.starts_at), 'LLLL, yyyy')}
            </p>
          </div>
        </a>
      </div>
    </div>
  );
};
export default PastEvent;
